// extracted by mini-css-extract-plugin
export default {"container":"styles_container__f601K","formContainer":"styles_formContainer__1fDWQ","actions":"styles_actions__jhXCx"};